// extracted by mini-css-extract-plugin
module.exports = {"ball-clip-rotate":"styles_ball-clip-rotate__37ZHY","rotate":"styles_rotate__1r-2K"};